"use client";

import { Text } from "@/components/atoms/Text/Text";
import { cn } from "@/lib/utils";
import {
  isConsentManagerConfigured,
  openConsentSettings,
} from "@/services/consent/consent";
import { useConsentManagerStatus } from "@/services/consent/useConsent";

interface Props {
  className?: string;
  // Runs before the dialog opens, e.g. to close a modal sheet that would
  // otherwise block clicks on Cookiebot's dialog.
  beforeOpen?: () => void | Promise<void>;
}

export function CookieSettingsLink({ className, beforeOpen }: Props) {
  const status = useConsentManagerStatus();

  if (!isConsentManagerConfigured() || status === "unavailable") return null;

  function handleClick() {
    if (!beforeOpen) return openConsentSettings();
    void Promise.resolve(beforeOpen()).then(openConsentSettings);
  }

  return (
    <button
      type="button"
      disabled={status !== "ready"}
      onClick={handleClick}
      data-slot="cookie-settings-link"
      className={cn(
        "group inline-flex items-center rounded-md px-2 py-1.5 focus-visible:ring-2 focus-visible:ring-info focus-visible:outline-none disabled:cursor-default disabled:opacity-60 sm:py-1",
        className,
      )}
    data-sentry-component="CookieSettingsLink" data-sentry-source-file="CookieSettingsLink.tsx">
      <Text
        variant="small"
        as="span"
        tone="secondary"
        data-slot="cookie-settings-link-label"
        className="underline-offset-2 group-hover:text-foreground-strong group-hover:underline group-disabled:no-underline"
      data-sentry-element="Text" data-sentry-source-file="CookieSettingsLink.tsx">
        Cookie settings
      </Text>
    </button>
  );
}
